import { render } from "./MultselectForm.vue?vue&type=template&id=bcf64ec0&scoped=true"
import script from "./MultselectForm.vue?vue&type=script&lang=js"
export * from "./MultselectForm.vue?vue&type=script&lang=js"

import "./MultselectForm.vue?vue&type=style&index=0&id=bcf64ec0&scoped=true&lang=css"

import exportComponent from "../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf64ec0"]])

export default __exports__